import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=1af004b1&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=js&"
export * from "./manage.vue?vue&type=script&lang=js&"
import style0 from "./manage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./manage.vue?vue&type=style&index=1&id=1af004b1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af004b1",
  null
  
)

export default component.exports